import React, { useMemo } from "react"
import { Box, Flex, Text, LinkBox, LinkOverlay } from "@chakra-ui/react"
import { Results } from "@usereactify/search"
import Link from "@app/components/Link"
import { useMedia } from "@app/hooks/useMedia"
import Image from "@app/components/Image/Image"

type Props = Parameters<NonNullable<Parameters<typeof Results>[0]["renderResultCardCallout"]>>[0]

const ProductGridCallout: React.FC<Props> = ({ callout }) => {
  const { isBase } = useMedia()

  const { content, title, link, desktopImage, mobileImage } = callout

  const image = useMemo(() => (isBase && mobileImage ? mobileImage : desktopImage || null), [desktopImage, isBase, mobileImage])

  return (
    <Flex maxW="180px" mr={3}>
      <LinkBox>
        <Box position="relative" justifyContent="center" alignItems="center" mb={2} overflow="hidden">
          {image && <Image w={"180px"} h="300px" objectFit={"cover"} src={image} alt={title} maxW="none" />}
        </Box>
        <Box maxW="100%" textAlign="center">
          <LinkOverlay as={Link} to={link} title={title}>
            <Text as="h3" size="lg" fontWeight="600">
              {title}
            </Text>
            <Text fontWeight="600">{content}</Text>
          </LinkOverlay>
        </Box>
      </LinkBox>
    </Flex>
  )
}

export default ProductGridCallout
